import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';
import { CaseRecordService } from '../../../services/case-record.service';

@Component({
  selector: 'case-record',
  templateUrl: './case-record.component.html',
  styleUrls: ['./case-record.component.scss'],
})
export class CaseRecordComponent implements OnInit {
  record: any[];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly caseRecordService: CaseRecordService
  ) {}
  id;
  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.getCaseRecord();
    });

    this.caseRecordService.updatedRecord.subscribe({
      next: (update) => {
        this.getCaseRecord();
      },
    });
  }
  getCaseRecord() {
    this.caseRecordService.getAllCaseRecord(this.id).subscribe({
      next: (record) => {
        this.record = record;
      },
    });
  }
}
